


























import { Vue, Component } from "vue-property-decorator";

import FullScreenLoading from "@/components/FullScreenLoading.vue";
import AlertError from "@/components/AlertError.vue";
import RequestSearch from "@/components/my-routine/RequestSearch.vue";
import RequestTable from "@/components/my-routine/RequestTable.vue";
import RequestTabs from "@/components/my-routine/RequestTabs.vue";

import MyRoutineUserController, {
  MyRoutineUser
} from "@/controller/my-routine-users";

const SOLVED_USERS_TAB_INDEX = 1;
const controller = new MyRoutineUserController();

@Component({
  components: {
    RequestTable,
    RequestTabs,
    AlertError,
    RequestSearch,
    FullScreenLoading
  }
})
export default class MyRoutineUsers extends Vue {
  users: MyRoutineUser[] = [];
  loading = false;
  isError = false;
  tabs = ["Chưa Tư Vấn", "Đã Tư Vấn"];
  currentTabIndex = 0;
  hasPreviousUsers = false;
  hasNextUsers = false;

  async created() {
    await this.fetchRequests();
  }

  async fetchRequests() {
    this.loading = true;

    try {
      this.users = await controller.fetchUsersFirstTime(this.isSolved);
      this.hasPreviousUsers = controller.hasPrevious;
      this.hasNextUsers = controller.hasNext;
    } catch (error) {
      this.isError = true;
    } finally {
      this.loading = false;
    }
  }

  get isSolved(): boolean {
    return this.currentTabIndex === SOLVED_USERS_TAB_INDEX;
  }

  async fetchNextRequests() {
    this.loading = true;

    try {
      this.users = await controller.fetchNextUsers(this.isSolved);
      this.hasPreviousUsers = controller.hasPrevious;
      this.hasNextUsers = controller.hasNext;
    } catch (error) {
      this.isError = true;
    } finally {
      this.loading = false;
    }
  }

  async fetchPreviousRequests() {
    this.loading = true;

    try {
      this.users = await controller.fetchPreviousUsers(this.isSolved);
      this.hasPreviousUsers = controller.hasPrevious;
      this.hasNextUsers = controller.hasNext;
    } catch (error) {
      this.isError = true;
    } finally {
      this.loading = false;
    }
  }

  async changeTab(tabIndex: number) {
    this.currentTabIndex = tabIndex;
    await this.fetchRequests();
  }

  async solveRequest(docId: string, email: string) {
    this.loading = true;

    try {
      await controller.updateMyRoutineUsersSolvedBy(docId, email);
      this.updateSolvedByLocally(docId, email);
    } catch (error) {
      this.toastError();
    } finally {
      this.loading = false;
    }
  }

  private updateSolvedByLocally(docId: string, email: string) {
    const userIndex = this.users.findIndex(user => user.id === docId);
    this.users[userIndex].solvedBy = email;
  }

  private toastError(message = "Lỗi hệ thống, vui lòng thử lại sau!") {
    this.$toasted.show(message, {
      theme: "toasted-primary",
      position: "top-right",
      icon: "mdi-home",
      duration: 2500,
      action: {
        text: "Tắt",
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        }
      }
    });
  }

  async deleteUser(docId: string) {
    if (!docId) {
      this.toastError("Vui lòng giữ phím SHIFT trước khi click xóa");
      return;
    }

    this.loading = true;

    try {
      await controller.deleteUser(docId);
      this.removeUserLocally(docId);
    } catch (error) {
      this.toastError();
    } finally {
      this.loading = false;
    }
  }

  private removeUserLocally(docId: string) {
    const userIndex = this.users.findIndex(user => user.id === docId);
    this.users.splice(userIndex, 1);
  }

  async searchRequestByPhone(phone: string) {
    this.loading = true;

    try {
      this.users = await controller.searchUsersByPhone(phone, this.isSolved);
      this.hasPreviousUsers = false;
      this.hasNextUsers = false;
    } catch (error) {
      this.isError = true;
    } finally {
      this.loading = false;
    }
  }
}
